import statusTooltip from './statusTooltip'

const withdraws = {
  statusTooltip,
}

export default withdraws
